import { useState } from 'react';

const faqs = [
  {
    question: 'What\'s the difference between Silver, Gold, and Platinum packages?',
    answer: 'Silver is perfect for hands-on hosts who want guidance to do most work themselves. Gold is full-service where we handle the heavy lifting like permits and contractor coordination. Platinum is our complete turnkey solution - we manage everything from design to launch, including hiring contractors and supervising the entire project on your behalf.'
  },
  {
    question: 'How does the phone support work?',
    answer: 'Silver includes 1 hour of phone consultation, Gold includes 5 hours, and Platinum includes unlimited phone access for the first 3 months. Additional phone or video training sessions can be purchased at $199 per hour for Silver and Gold packages. You can schedule these sessions at your convenience.'
  },
  {
    question: 'Can I upgrade from Silver or Gold to a higher package?',
    answer: 'Absolutely! Many clients start with Silver or Gold and upgrade as they realize the value of more comprehensive support. We\'ll credit your previous package fee toward the upgraded package cost.'
  },
  {
    question: 'What areas do you serve?',
    answer: 'We provide services nationwide, with expertise in local codes and regulations across different states and municipalities. Our contractor network spans major metropolitan areas and popular vacation destinations.'
  },
  {
    question: 'How long does the setup process take?',
    answer: 'Timeline varies based on your property\'s condition and local permit requirements. Silver package guidance can be completed in 2-4 weeks. Gold package full setup typically takes 6-12 weeks. Platinum package with complete turnkey service usually takes 8-16 weeks, depending on renovation scope and permit processing times.'
  },
  {
    question: 'Do you offer ongoing management services?',
    answer: 'Yes! While our Silver, Gold, and Platinum packages focus on setup and launch, we also offer comprehensive property management services. Contact us to learn about our management plans and pricing.'
  },
  {
    question: 'What if I need help after my package hours are used?',
    answer: 'You can purchase additional phone/video support at $199 per hour for Silver and Gold packages. Platinum clients receive unlimited phone access for 3 months. We also offer unlimited chat support with all packages, so you can always reach out with quick questions.'
  },
  {
    question: 'Is there a money-back guarantee?',
    answer: 'We stand behind our services. If you\'re not satisfied within the first 30 days, we\'ll work with you to make it right or provide a refund for unused services.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#1A2332] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our service packages
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-[#FAF8F5] rounded-2xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#f5f2ed] transition-colors cursor-pointer"
              >
                <span className="text-lg font-bold text-[#1A2332] pr-8">
                  {faq.question}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 bg-[#FF6B6B] rounded-full flex items-center justify-center transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-white text-xl"></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
